interface AIRationaleCardProps {
  rationale: string;
}

function AIRationaleCard({
  rationale,
}: AIRationaleCardProps) {
  return (
    <section className="card">
      <h2 className="sidebar-heading">AI RATIONALE</h2>

      <p className="text-muted">
        {rationale}
      </p>
    </section>
  );
}

export default AIRationaleCard;